/// <reference path="../../styled.d.ts" />

import * as React from 'react';
import { Message } from '../Translate';
import * as s from './styles';

export type EmptyStateImage =
  | 'calendar'
  | 'deficiency'
  | 'equipment'
  | 'field'
  | 'floorplan'
  | 'generic'
  | 'inspection'
  | 'location'
  | 'model'
  | 'question'
  | 'service'
  | 'serviceMonth';

interface EmptyStateProps {
  title: Message;
  subtitle: Message;
  image?: EmptyStateImage;
}

const imageMap = {
  calendar: require('./images/calendar.jpg'),
  deficiency: require('./images/deficiency.jpg'),
  equipment: require('./images/equipment.jpg'),
  field: require('./images/field.jpg'),
  floorplan: require('./images/floorplan.jpg'),
  generic: require('./images/generic.jpg'),
  inspection: require('./images/inspection.jpg'),
  location: require('./images/location.jpg'),
  model: require('./images/model.jpg'),
  question: require('./images/question.jpg'),
  service: require('./images/service.jpg'),
  serviceMonth: require('./images/service-month.jpg'),
};

function getImageSource(image: EmptyStateImage) {
  const source = imageMap[image];
  const uri = typeof source === 'string' ? source : source.default;
  return uri ? { uri } : source;
}

export const EmptyState = (props: EmptyStateProps) => {
  const image = getImageSource(props.image || 'generic');

  return (
    <s.Container>
      <s.InnerContainer>
        <s.Illustration source={image} resizeMode="contain" />
        <s.Title>{props.title}</s.Title>
        <s.SubTitle>{props.subtitle}</s.SubTitle>
      </s.InnerContainer>
    </s.Container>
  )
}
